import { CashFlowExpenseSalaryItem } from "bus/cash/types/cashFlowExpenseSalary";

export const initValue: CashFlowExpenseSalaryItem = {
  comment: '',
  date: '',
  issued: 0,
  toPay: 0,
  cashFlowAccount: null,
  cashFlowItemId: null
};